import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import { cyan900 } from 'material-ui/styles/colors';
import { fetchProducts } from '../../actions/';
import Checkbox from 'material-ui/Checkbox';
import Pagination from '../home/Pagination';
import _ from 'lodash';

const propTypes = {
  category: PropTypes.any,
  products: PropTypes.any,
  onSave: PropTypes.func,
  productsMeta: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class ViewCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      categoryProductsList: [],
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let categories = nextProps.categories;
    if (nextProps.categories.category.id) {
      categories = nextProps.categories;
    } else {
      categories.category = nextProps.categories.results[0];
    }
    categories.category.id = (categories.category.id === null) ? 0 : categories.category.id;
    categories.category.products = nextProps.products;
    this.setState({ categories });
  }
  navigation(route) {
    this.props.dispatch(fetchProducts(route));
  }
  handleCancel() {
    browserHistory.push('/categories');
  }
  navigateToEdit() {
    browserHistory.push(`/categories/${this.props.category.id}`);
  }
  renderCategoryProductsTableRows() {
    const categoryProducts = this.props.products;
    // const isDisabled = true;

    if (!categoryProducts) { return ''; }

    return categoryProducts.map((product, i) =>
      <TableRow key={i}>
        <TableRowColumn key={`${i}`}>{product.name}</TableRowColumn>
        <TableRowColumn key={`${i}`}>{product.description}</TableRowColumn>
        <TableRowColumn key={i}>
          <Checkbox
            checked={product.allowsPersonalization}
          //  disabled={isDisabled}
          />
        </TableRowColumn>
        <TableRowColumn key={i}>
          <Checkbox
            checked={product.disabled}
            // disabled={isDisabled}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      wideStyle:{
        marginRight: '2%',
        width: '700px',
      }
    };
    return (
      <div>
        <div className="content">
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Edit"
              primary
              onClick={this.navigateToEdit}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.props.category.id}
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.category.name}
            name="name"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Tagline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.category.tagline}
            name="tagline"
            style={styles.inputStyle}
            multiLine={true}
          />
          <TextField
            floatingLabelText="Image Url"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.category.img || ''}
            name="img"
            style={styles.inputStyle}
          />
          <br/>
        <TextField
            floatingLabelText="Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.category.description}
            name="name"
            style={styles.wideStyle}
            multiLine={true}
          />
        </div>
        <br />
        <br />
        <h2>Category Products</h2>
        <div className="content">
          <br />
          <div className="action-buttons top">
            <Pagination
              paginationInfo={this.props.productsMeta}
              pageCall={route => this.navigation(route)}
              pageName={`/categories/view/${_.get(this, 'props.category.id')}`}
            />
          </div>
          <Table selectable={false} wrapperStyle={{ overflow: 'inherit' }}>
            <TableHeader
              displaySelectAll={tableStyles.displaySelectAll}
              adjustForCheckbox={tableStyles.adjustForCheckbox}
            >
              <TableRow
                selectable={tableStyles.selectable}
              >
                <TableHeaderColumn>Name</TableHeaderColumn>
                <TableHeaderColumn>Description</TableHeaderColumn>
                <TableHeaderColumn>Allows Personalization</TableHeaderColumn>
                <TableHeaderColumn>Disabled</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              stripedRows={tableStyles.stripedRows}
              displayRowCheckbox={tableStyles.displayRowCheckbox}
            >
              {this.renderCategoryProductsTableRows()}
            </TableBody>
          </Table>
          <br />
          <br />
          <div className="action-buttons top">
            <Pagination
              paginationInfo={this.props.productsMeta}
              pageCall={route => this.navigation(route)}
              pageName={`/categories/view/${_.get(this, 'props.category.id')}`}
            />
          </div>
        </div>
      </div>
    );
  }
}

ViewCategory.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewCategory.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    category: state.categories.category,
    categories: state.categories,
    products: state.products.results,
    productsMeta: state.products.meta,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(ViewCategory));



// WEBPACK FOOTER //
// ./src/components/categories/ViewCategory.js